// extracted by mini-css-extract-plugin
export default {"agenda":"Agenda-agenda-hRnz8"};